import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import { FrequentlyAskedQuestionAnswer } from './frequently-asked-question-answer';
import {FrequentlyAskedQuestionAnswersService} from '../frequently-asked-question-answers.service';
import {Results} from '../../core/results';
declare var $: any;
@Directive({
  selector: '[appFrequentlyAskedQuestionAnswer]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FrequentlyAskedQuestionAnswerDirective),
    multi: true
  }]
})
export class FrequentlyAskedQuestionAnswerDirective implements ControlValueAccessor, OnInit {

  @Input() private frequentlyAskedQuestionAnswer: FrequentlyAskedQuestionAnswer;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: FrequentlyAskedQuestionAnswersService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Frequently Asked Question Answer',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<FrequentlyAskedQuestionAnswer>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.answer,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.frequentlyAskedQuestionAnswer = JSON.parse(e.params.data.id);
      that.propagateChange(that.frequentlyAskedQuestionAnswer);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.frequentlyAskedQuestionAnswer = null;
      that.propagateChange(that.frequentlyAskedQuestionAnswer);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(frequentlyAskedQuestionAnswer: FrequentlyAskedQuestionAnswer): void {

    this.frequentlyAskedQuestionAnswer = frequentlyAskedQuestionAnswer;
    this.propagateChange(this.frequentlyAskedQuestionAnswer);
    const that = this;
    if (this.frequentlyAskedQuestionAnswer !== undefined && this.frequentlyAskedQuestionAnswer !== null) {
      const option = new Option(frequentlyAskedQuestionAnswer.answer, JSON.stringify(frequentlyAskedQuestionAnswer), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.frequentlyAskedQuestionAnswer;
  }

  set value(v: any) {
    if (v !== this.frequentlyAskedQuestionAnswer) {
      this.frequentlyAskedQuestionAnswer = v;
      this.propagateChange(v);
    }
  }

}
